import React, { useContext, useEffect, useState } from "react";
import {
  Box,
  Card,
  CardContent,
  Typography,
  Grid,
  TextField,
  Button,
} from "@mui/material";
import ApiEndpoints from "../network/ApiEndPoints";
import { postJsonData } from "../network/ApiController";
import AuthContext from "../store/AuthContext";
import { apiErrorToast, okSuccessToast } from "../utils/ToastUtil";
const CommonBbpsView2 = ({ type }) => {
  const [billers, setBillers] = useState([]);
  const [progress, setProgress] = useState(false);
  const authCtx = useContext(AuthContext);
  const location = authCtx.location;
  const [selectedBiller, setSelectedBiller] = useState(null);
  const [caNumber, setCaNumber] = useState("");
  const [amount, setAmount] = useState("");
  const [mpin, setMpin] = useState(["", "", "", "", "", ""]);
  const [search, setSearch] = useState("");
  const getBillers = (cat_key) => {
    postJsonData(
      ApiEndpoints.BBPS_GET_BILLERS,
      { categoryKey: cat_key },
      setProgress,
      (res) => {
        setBillers(res.data.data || []);
      },
      (err) => {
        console.log(err);
      },
    );
  };

  useEffect(() => {
    getBillers(type);
  }, []);

  const handlePayBill = () => {
    const data = {
      operator: selectedBiller.id,
      code: selectedBiller.code,
      biller_name: selectedBiller.name,
      amount: amount,
      pan: undefined,
      pf: "web",
      cat: type,
      mpin: mpin.join(""),
      latitude: location.lat,
      longitude: location.long,
      enquiryReferenceId: "15486sfdgyf",
      param1: caNumber,
    };

    postJsonData(
      ApiEndpoints.RECH_PAY_BILL,
      data,
      setProgress,
      (res) => {
        // console.log(res);
        okSuccessToast(res.data.message);
      },
      (error) => {
        console.log(error);
        apiErrorToast(error);
      },
    );
  };
  const handleMpinChange = (value, index) => {
    if (!/^\d?$/.test(value)) return;

    const newMpin = [...mpin];
    newMpin[index] = value;
    setMpin(newMpin);

    if (value && index < 5) {
      document.getElementById(`mpin-${index + 1}`)?.focus();
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && !mpin[index] && index > 0) {
      document.getElementById(`mpin-${index - 1}`)?.focus();
    }
  };
  const filteredBillers = billers.filter((item) =>
    item.name.toLowerCase().includes(search.toLowerCase()),
  );
  if (selectedBiller) {
    return (
      <Box p={3}>
        <Button
          variant="outlined"
          onClick={() => setSelectedBiller(null)}
          sx={{ mb: 2 }}
        >
          Back
        </Button>

        <Typography variant="h5" gutterBottom>
          {selectedBiller.name}
        </Typography>

        <Typography color="text.secondary" mb={3}>
          Code : {selectedBiller.code}
        </Typography>

        <TextField
          fullWidth
          label="CA Number"
          value={caNumber}
          onChange={(e) => setCaNumber(e.target.value)}
          sx={{ mb: 2 }}
        />

        <TextField
          fullWidth
          label="Amount"
          type="number"
          value={amount}
          onChange={(e) => setAmount(e.target.value)}
          sx={{ mb: 3 }}
        />
        <Typography sx={{ mb: 1 }}>Enter 6 Digit MPIN</Typography>

        <Box sx={{ display: "flex", gap: 1, mb: 3 }}>
          {mpin.map((digit, index) => (
            <TextField
              key={index}
              id={`mpin-${index}`}
              value={digit}
              onChange={(e) => handleMpinChange(e.target.value, index)}
              onKeyDown={(e) => handleKeyDown(e, index)}
              inputProps={{
                maxLength: 1,
                style: {
                  textAlign: "center",
                  fontSize: "22px",
                },
              }}
              type="password"
              sx={{
                width: 55,
                "& .MuiOutlinedInput-root": {
                  height: 55,
                },
              }}
            />
          ))}
        </Box>
        <Button
          variant="contained"
          fullWidth
          onClick={handlePayBill}
          disabled={!caNumber || !amount || mpin.length !== 6}
        >
          Pay Bill
        </Button>
      </Box>
    );
  }

  return (
    <Box p={2}>
      <Typography variant="h5" mb={2}>
        Electricity Billers
      </Typography>

      <TextField
        fullWidth
        label="Search Biller"
        variant="outlined"
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        sx={{ mb: 3 }}
      />

      <Grid container spacing={2}>
        {filteredBillers.map((item) => (
          <Grid item xs={12} md={4} key={item.id}>
            <Card
              sx={{ cursor: "pointer" }}
              onClick={() => setSelectedBiller(item)}
            >
              <CardContent>
                <Typography variant="h6">{item.name}</Typography>

                <Typography color="text.secondary">
                  Code : {item.code}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>

      {!progress && billers.length === 0 && (
        <Typography>No Billers Found</Typography>
      )}
    </Box>
  );
};

export default CommonBbpsView2;
